import React from 'react';
import { useTranslation } from '../../../../../contexts/I18nProvider';
import { X } from 'lucide-react';

interface ImageModalProps {
  isOpen: boolean;
  imageUrl: string;
  onClose: () => void;
}

export const ImageModal: React.FC<ImageModalProps> = ({
  isOpen,
  imageUrl,
  onClose
}) => {
  const { t } = useTranslation();
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-75 flex items-center justify-center z-50 p-0 sm:p-4">
      <div className="bg-white w-full h-full sm:h-auto sm:rounded-lg sm:max-w-4xl sm:max-h-full overflow-auto">
        <div className="p-4 border-b border-gray-200 flex items-center justify-between">
          <h3 className="text-lg font-semibold">{t('warehouse.modules.picking.imageModal.title')}</h3>
          <button
            onClick={onClose}
            className="text-gray-500 hover:text-gray-700 min-h-[44px] min-w-[44px] flex items-center justify-center"
          >
            <X size={24} />
          </button>
        </div>
        <div className="p-4">
          <img
            src={imageUrl}
            alt={t('warehouse.modules.picking.imageModal.altEnlarged')}
            className="max-w-full h-auto"
          />
        </div>
      </div>
    </div>
  );
};